import script from "./MenuManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuManagement.vue?vue&type=script&setup=true&lang=js"

import "./MenuManagement.vue?vue&type=style&index=0&id=195f6cea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-195f6cea"]])

export default __exports__